import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AnimatePresence } from 'framer-motion';
import { useAnimationConfig } from '../../context/occ/hooks/use-animation-config';
/**
 * Framer Motion's `<AnimatePresence>` component **is required** when you intend to animate elements
 * out of the DOM. It also automatically responds based on whether or not reduced motion is enabled
 * on the user OS. This component is a small helper component designed to avoid the case where you
 * would otherwise end up with multiple ternary statements littered throughout the codebase.
 *
 * @example
 * <AnimateOut>
 *   {items.map(i => <motion.div>{i}</motion.div>)}
 * </AnimateOut>
 */
export const AnimateOut = props => {
    const { children } = props;
    const { enableAnimations } = useAnimationConfig();
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return enableAnimations ? _jsx(AnimatePresence, { children: children }) : _jsx(_Fragment, { children: children });
};
AnimateOut.displayName = 'AnimateOut';
//# sourceMappingURL=animate-out.js.map